import React, { Component } from 'react';
import { View, Text, ScrollView, StyleSheet,  Picker, Button, Dimensions } from 'react-native';
import {  ButtonGroup } from 'react-native-elements';
import { Table, Row } from 'react-native-table-component';
const { width } = Dimensions.get('window');
import CustomDatePicker from '../components/CustomDatePickerComponent/CustomDatePickerComponent';
import ReportsTable from '../components/ReportTableComponent/ReportTableComponent';
import axios from 'axios';
import UserPersistence from '../singletons/UserPersistence';
import config from '../../config.json'
class Reports extends Component {
  constructor(props) {
    super(props);
    this.state = {
        screenWidth: width,
        selectedIndex: 0,
        tableHead: ['Date', 'Running Time', 'Vehicle Name','In State', 'Total Mileage'],
        widthArr: ['15%', '15%', '15%', '30%','25%'],
        reports: [],
        dailyReports: [],
        stateReports: [],
        dailyStopsReport: [],
        filterDailyStopsReport: [],
        rangedate: new Date(),
        DatePickerVisible: false,
        startDate: null,
        endDate: null,
        focusedInput: '',
        scrollViewStyle: styles.scrollViewContainer,
        datePickerHeight: 20,
        isCalendarOpen: false,
        isDatePickerOpen: false,
        loading:'',
        selectedVehicle: null,
        vehicleList: UserPersistence.getInstance().vehicleInfo,
        selectedVehicleId: '',
        titles: ['Report Of Driving Mileage','Stop Points Report','Days Stop Report']
    };
    this.milerecords = [];
    this.stoprecords = [];
    this.daysStoprecords = [];
  }
    //控制起始日期和结束日期
    handleStartChange = (selectedDate) => {
        this.setState({ 
            startDate: selectedDate,
        });
    };
    handleEndChange = (selectedDate) => {
        this.setState({ 
            endDate: selectedDate, 
        });
    };
    // setPickerHeight = (pickerHeight)=> {
    //     this.setState({
    //         datePickerHeight: pickerHeight,
    //     })
    // }


    //获取某辆车的日常和州英里数
    getMileageReport() {
        this.setState({
            tableHead: ['Date', 'Running Time', 'Vehicle Name','In State', 'Total Mileage'],
            widthArr: ['15%', '15%', '15%', '30%','25%'],
            reports: [],
            loading: 'Loading......'
        });

        if(this.state.selectedVehicleId){
            axios({
                method: "get",
                url: config.user.protocol + config.user.address + ':' + config.user.port + '/getMileageReportsByDate'+ "?vid="+ this.state.selectedVehicleId +"&begin=" + this.secondConverter(this.state.startDate) + "&end=" + this.secondConverter(this.state.endDate),
                // timeout: 1000 * 60,
                headers: { 
                "Content-Type":   "application/json",
                "X-Auth-User":    UserPersistence.getInstance().userId,
                "X-Auth-Token":   UserPersistence.getInstance().userAccessToken
                },
                data :{}  //no body for post
            })
            .then(res => {
                if ( this.isResponseOk(res) ) {
                    var dailyReports = res.data;
                    console.log(dailyReports);
                    this.setState({
                        dailyReports: dailyReports, 
                        loading: ''
                    })
                    //执行下一个axios请求按照州获取当前车的英里数
                    this.getStateMileage();

                } else {
                    alert('Cant get Report by date');
                    this.setState({ 
                        loading: ''
                    })
                }
            })
            .catch(err =>{
                alert('Cant get Report ,please try again ,Error ' + err.message);
                this.setState({ 
                    loading: ''
                })
            });
        }else{
            alert("Please select a vehicle first");
            this.setState({ 
                loading: ''
            })
        }
    }
    //获取选择车辆的州历程信息
    getStateMileage(){
        if(this.state.selectedVehicleId){
            axios({
                method: "get",
                url: config.user.protocol + config.user.address + ':' + config.user.port + '/getMileageReportByState'+ "?vid="+ this.state.selectedVehicleId +"&begin=" + this.secondConverter(this.state.startDate) + "&end=" + this.secondConverter(this.state.endDate),
                // timeout: 1000 * 60,
                headers: { 
                "Content-Type":   "application/json",
                "X-Auth-User":    UserPersistence.getInstance().userId,
                "X-Auth-Token":   UserPersistence.getInstance().userAccessToken
                },
                data :{}  //no body for post
            }).then( res => {
                if(this.isResponseOk(res)){
                    var stateReports = res.data;
                    console.log(stateReports);
                    this.setState({
                        stateReports: stateReports,
                    })

                    this.combineDailyreportsAndStateReprots()
                }else{
                    alert('Cant get Report by state')
                    this.setState({ 
                        loading: ''
                    })
                }
            }).catch(err =>{
                alert('Cant get Report ,please try again ,Error ' + err.message);
                this.setState({ 
                    loading: ''
                })
            })
        }else{
            alert("Please select a vehicle first");
            this.setState({ 
                loading: ''
            })
        }
    }
    //得到dailyreports 和 statereports以后 将他们组合成为reports
    combineDailyreportsAndStateReprots = () => {
        const dailyReports = this.state.dailyReports;
        const stateReports = this.state.stateReports;
        const combineReports = [];

        for(let i = 0; i < dailyReports.length; i++){
            const {date, startTime, endTime, nickName, totalMileage} = dailyReports[i];
            const currentDate = date;
            const runningDate = this.toYYMMDD(date);
            const runningTime = `${this.toHHMMSS(startTime)} to ${this.toHHMMSS(endTime)}`; 
            let locationAndMile = {runningDate, runningTime, nickName, totalMileage};
            const combineStr = stateReports
                          .filter((report) => report.date === currentDate)
                          .map((report) => `${report.location}=${report.stateMileage}`)
                          .join(", ");
            locationAndMile = {...locationAndMile, combineStr};

            combineReports.push(locationAndMile);
        }
        this.setState({
            reports: combineReports,
        })
    }
    //获取用户选择的日期一天内的所有停车点信息，startDate是用户选择的 endDate = startDate + (24*60*60-1) 
    getStopReport() {
        this.setState({
            tableHead:['#','Start Time','Leave Time','Stop Time','Engine On','Address'],
            widthArr:['5%','10%','10%','12.5%','12.5%','50%'],
            reports:[],
            loading: 'Loading......'
        });
        if(this.state.selectedVehicleId){
            axios({
                method: "get",
                url: config.user.protocol + config.user.address + ':' + config.user.port + '/getStopPoints'+ "?vid="+ this.state.selectedVehicleId +"&begin=" + this.secondConverter(this.state.startDate) + "&end=" + (this.secondConverter(this.state.startDate)+86399),
                // timeout: 1000 * 60,
                headers: { 
                "Content-Type":   "application/json",
                "X-Auth-User":    UserPersistence.getInstance().userId,
                "X-Auth-Token":   UserPersistence.getInstance().userAccessToken
                },
                data :{}  //no boday for post
            })
            .then(res => {
                if ( this.isResponseOk(res) ) {
                    var dailyStopsReport = res.data;
                    console.log(res.data);
                    this.setState({
                        dailyStopsReport: dailyStopsReport
                    })
                    this.retrieveAllStopPoints();
                } else {
                    alert('Cat get days stop Report');
                    this.setState({ 
                        loading: ''
                    })
                }
            })
            .catch(err =>{
                alert('Cant get Report ,please try again , '+err.message);
                this.setState({ 
                    loading: ''
                })
            });
        }else {
            alert("Please select a vehicle first");
            this.setState({ 
                loading: ''
            })
        }
    }

    //过滤掉相同的停车点，保存不同的停车点存在state中的filterDailyStopsReport
    retrieveAllStopPoints = ()=> {
        const allStopPoints = this.state.dailyStopsReport;
        let result = [];
        if(allStopPoints.length===1){
            return result [{
                latitude: allStopPoints[0].latitude,
                longtitude: allStopPoints[0].longtitude,
                date: allStopPoints[0].date,
                startTime: allStopPoints[0].time,
                leaveTime: allStopPoints[0].time,
                engine: allStopPoints[0].engine,
            }]
        }

        let sameStopPoints = [];
        sameStopPoints.push(allStopPoints[0]);
        let preLatitude = Math.floor(allStopPoints[0].latitude);
        let preLongtitude = Math.floor(allStopPoints[0].longtitude);
      
        for (let i = 1; i < allStopPoints.length; i++) {
            const currentStopPoint = allStopPoints[i];
            const curLatitude = Math.floor(currentStopPoint.latitude);
            const curLongtitude = Math.floor(currentStopPoint.longtitude);

            if(preLatitude===curLatitude && preLongtitude === curLongtitude){
                sameStopPoints.push(currentStopPoint)
            }else{
                if(sameStopPoints.length > 0){
                    result.push({
                        latitude: sameStopPoints[0].latitude,
                        longtitude: sameStopPoints[0].longtitude,
                        date: sameStopPoints[0].date,
                        startTime: sameStopPoints[0].time,
                        leaveTime: sameStopPoints[sameStopPoints.length-1].time,
                        engine: sameStopPoints.reduce((sum, stopPoint)=> sum + parseInt(stopPoint.engine), 0),
                    })

                    sameStopPoints = [];
                }

                sameStopPoints.push(currentStopPoint);
                preLatitude = curLatitude;
                preLongtitude = curLongtitude;

            }
        }

        if(sameStopPoints.length > 0){
            result.push({
                latitude: sameStopPoints[0].latitude,
                longtitude: sameStopPoints[0].longtitude,
                date: sameStopPoints[0].date,
                startTime: sameStopPoints[0].time,
                leaveTime: sameStopPoints[sameStopPoints.length-1].time,
                engine: sameStopPoints.reduce((sum, stopPoint)=> sum + parseInt(stopPoint.engine), 0),
            })

            sameStopPoints = [];
        }

        this.setState({
            filterDailyStopsReport: result
        })

        this.handleFilterDailyStopsReport()

        return result;
    }

    //通过lat 和 lng的值获取地址信息
    getAddressByLatAndLng = async (lat, lng) => {
        try {
          const response = await fetch(
            'https://maps.googleapis.com/maps/api/geocode/json?address=' +
            lat +
            ',' +
            lng +
            '&key=AIzaSyDXtwQ9T63QewTtokZExpuC4xDdiW1empE'
          );
          const responseJson = await response.json();
          const address = responseJson.results[0].formatted_address.replace(', USA', '');
          console.log('已经拿到address: ' + address);
          return address;
        } catch (error) {
          console.log('Error fetching address:', error);
          return null;
        }
      };
      
    //进一步处理filterDailyStopsReport 将需要的信息保存在reports数组中
    handleFilterDailyStopsReport = async() =>{
        const filterDailyStopsReport = this.state.filterDailyStopsReport;

        const handledFilterDailyStopsReport = [];

        for(let i = 0; i < filterDailyStopsReport.length; i++){
            const {latitude, longtitude, date ,startTime, leaveTime, engine} = filterDailyStopsReport[i];
            const lat = this.ConvertToLat(latitude);
            const lng = this.ConvertToLng(longtitude);
            
            const address = await this.getAddressByLatAndLng(lat, lng)
            const dateYYMMDD = this.toYYMMDD(date)
            const Num = i+1;
            const startHHMMSS = this.toHHMMSS(startTime);
            const leaveHHMMSS = this.toHHMMSS(leaveTime);
            const stopTime = this.getTimeDifference(startTime, leaveTime);
            const engineOn = this.formatTime(engine);

            handledFilterDailyStopsReport.push({
                Num, dateYYMMDD, startHHMMSS, leaveHHMMSS, stopTime, engineOn, address,
            });
        }

        this.setState({
            reports: handledFilterDailyStopsReport,
            loading: '',
        })
        return handledFilterDailyStopsReport;
    }

    //获取停车点位报告
    getDaysStopReport() {
        this.setState({
            tableHead:['#','Date','Start Time','Leave Time','Stop Time','Engine On','Address'],
            widthArr:['5%', '10%', '10%','10%','12.5%','12.5%','40%'],
            reports:[],
            loading: 'Loading......'
        });
        if(this.state.selectedVehicleId){
            axios({
                method: "get",
                url: config.user.protocol + config.user.address + ':' + config.user.port + '/getStopPoints'+ "?vid="+ this.state.selectedVehicleId +"&begin=" + this.secondConverter(this.state.startDate) + "&end=" + this.secondConverter(this.state.endDate),
                timeout: 1000 * 60,
                headers: { 
                "Content-Type":   "application/json",
                "X-Auth-User":    UserPersistence.getInstance().userId,
                "X-Auth-Token":   UserPersistence.getInstance().userAccessToken
                },
                data :{}  //no boday for post
            })
            .then(res => {
                if ( this.isResponseOk(res) ) {
                    var dailyStopsReport = res.data;
                    this.setState({
                        dailyStopsReport: dailyStopsReport
                    })

                    this.retrieveAllStopPoints();
                } else {
                    alert('Cant get days stop Report');
                    this.setState({ 
                        loading: ''
                    })
                }
            })
            .catch(err =>{
                alert('Cant get Report ,please try again , '+err.message);
                this.setState({ 
                    loading: ''
                })
            });
        }else{
            alert("Please select a vehicle first");
            this.setState({ 
                loading: ''
            })
        }
    }


    //查看axios是否获取到数据
    isResponseOk(res) {
        if (res.status == 200 && res.data!=null) {
            return true;
        } else {
            return false;
        }
    }

    //辅助函数 将time转换成hh:mm:ss
    toHHMMSS = (timestr) => {
        const hours = Math.floor(parseInt(timestr) / 10000);
        const minutes = Math.floor((parseInt(timestr) % 10000) / 100);
        const seconds = parseInt(timestr) % 100;

        const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        return formattedTime;
    }
    //辅助函数 将date转换成yyyy-mm-dd
    toYYMMDD = (datestr) => {
        const year = datestr.substring(4, 6);
        const month = datestr.substring(2, 4);
        const day = datestr.substring(0, 2);
      
        const formattedDate = `20${year}-${month}-${day}`;
        return formattedDate;
      };
    //参数是一个整数表示总过有多少秒 将他变成xx hours xx min xx second的格式
    formatTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;
      
        const formattedTime = `${hours} hours ${minutes} minutes ${remainingSeconds} seconds`;
        return formattedTime;
    }
    //参数是两个字符串，求出他们的时间差 返回xx hours xx min xx second的格式
    getTimeDifference = (startTime, leaveTime) => {
        const startHours = parseInt(startTime.substring(0, 2));
        const startMinutes = parseInt(startTime.substring(2, 4));
        const startSeconds = parseInt(startTime.substring(4, 6));
      
        const leaveHours = parseInt(leaveTime.substring(0, 2));
        const leaveMinutes = parseInt(leaveTime.substring(2, 4));
        const leaveSeconds = parseInt(leaveTime.substring(4, 6));
      
        const totalStartSeconds = startHours * 3600 + startMinutes * 60 + startSeconds;
        const totalLeaveSeconds = leaveHours * 3600 + leaveMinutes * 60 + leaveSeconds;
        const timeDifferenceSeconds = totalLeaveSeconds - totalStartSeconds;
      
        const hours = Math.floor(timeDifferenceSeconds / 3600);
        const minutes = Math.floor((timeDifferenceSeconds % 3600) / 60);
        const seconds = timeDifferenceSeconds % 60;
      
        const formattedTime = `${hours} hours ${minutes} minutes ${seconds} seconds`;
        return formattedTime;
    }

    //buttonGroup 按钮组功能 改变state中的selectedIndex
    buttonPress(selectedIndex) {
        this.state.selectedIndex = selectedIndex;
        console.log("selectedIndex in state is: "+ this.state.selectedIndex);
        console.log("selectedIndex in function is: "+ selectedIndex);
        if(selectedIndex == 0) {
            this.backToVehicle();
        } else if(selectedIndex == 1) {
            this.backToStop();  
        }else if(selectedIndex == 2) {
            this.backToDays();
        }
    }
    //导航功能 跳转到mileage reports
    backToVehicle() {
        if(this.state.selectedIndex == 0) {
        
            var reports = []
            this.setState({
                tableHead: ['Date', 'Running Time', 'Vehicle Name','In State', 'Total Mileage'],
                widthArr: ['15%', '15%', '15%', '30%','25%'],
                selectedVehicle: null,
                reports: reports, 
                loading: '',
            });
        } 
    }
    //导航功能 跳转到stops reports
    backToStop() {
        var reports = []
        this.setState({
            tableHead:['#','Start Time','Leave Time','Stop Time','Engine On','Address'],
            widthArr:['5%','10%','10%','12.5%','12.5%','50%'],
            selectedVehicle: null,
            reports: reports,
            loading: '',
        });
        
    }
     //导航功能 跳转到days stops reports
    backToDays() {
        var reports = [];
        this.setState({
            tableHead:['#','Date','Start Time','Leave Time','Stop Time','Engine On','Address'],
            widthArr:['5%', '10%', '10%', '10%', '12.5%', '12.5%', '40%'],
            selectedVehicle: null,
            reports: reports,
            loading: ''
        })
    }
    //将得到的latitude字符转 转换成double类型
    ConvertToLat(LatStr) {
        var LatDegrees = parseInt(LatStr.substring(0, 3));
        var LatMinutes = parseFloat(LatStr.substring(3))/60;
        var  LatitudeDouble = LatDegrees + LatMinutes;
        return LatitudeDouble;
    }
    //将得到的longtitude字符转 转换成double类型
    ConvertToLng(LongStr) {
        var LongDegrees = parseInt(Math.abs(parseFloat(LongStr.substring(0, 4))));
        var LongMinutes = parseFloat(LongStr.substring(4))/60;
        var  LongtitudeDouble = 0- (LongDegrees + LongMinutes);
        return LongtitudeDouble;
    }
    //将时间转换成sql查询需要的second值 以2007年1月1日作为起始日子
    secondConverter = (time) => {
        const baseTime = new Date(2007, 0, 1); // 以2007-01-01 作为起始时间
        const currentSecond = Math.floor(time.getTime()/1000); //转换成秒为单位
        const baseSecond = Math.floor(baseTime.getTime()/1000); // 计算基准的second
        const convertedSecond = currentSecond-baseSecond;
        return convertedSecond+3600;
    }
    //监听picker中选中的车辆，获取对应车辆的vehicleId
    handleVehicleChange = (vehicleId) =>{
        this.setState({
            selectedVehicleId: vehicleId
        })
        console.log(this.state.selectedVehicleId);
    }
    //report按钮的功能
    btnReport = () =>{
        if(this.state.selectedIndex==0){
            if(this.state.stateReports.length!=0){
                this.setState({
                    stateReports: [],
                })
            }
            this.getMileageReport();
        }else if(this.state.selectedIndex ==1){
            this.getStopReport();
        }else if(this.state.selectedIndex==2){
            this.getDaysStopReport();
        }
    }

    //根据选择要查看报告的selectIndex 返回数据
    data = (vehicleInfo) => {
        if(this.state.selectedIndex===0){
            return[
                vehicleInfo.runningDate,
                vehicleInfo.runningTime,
                vehicleInfo.nickName,
                vehicleInfo.combineStr,
                vehicleInfo.totalMileage
            ]
        }else if(this.state.selectedIndex===1){
            return[
                vehicleInfo.Num, 
                vehicleInfo.startHHMMSS, 
                vehicleInfo.leaveHHMMSS, 
                vehicleInfo.stopTime, 
                vehicleInfo.engineOn, 
                vehicleInfo.address,
            ]
        }else if(this.state.selectedIndex===2){
            return[
                vehicleInfo.Num,
                vehicleInfo.dateYYMMDD, 
                vehicleInfo.startHHMMSS, 
                vehicleInfo.leaveHHMMSS, 
                vehicleInfo.stopTime, 
                vehicleInfo.engineOn, 
                vehicleInfo.address,
            ]
        }
    }

    render() {
        const { screenWidth } = this.state;
        // const tableWidth = screenWidth * 0.2;

        return (
            <ScrollView contentContainerStyle ={styles.container}>
                <View style = {styles.contentView}>
                    <View style = {styles.buttonsContainer}>
                        <ButtonGroup
                            buttons={['Mileage Report', 'Stops Report', 'Days Stops Report']}
                            selectedIndex={this.state.selectedIndex}
                            onPress={selectedIndex => {
                                this.buttonPress(selectedIndex)
                            }}
                            containerStyle={{width:'70%', marginBottom: 20 }}
                        />
                    </View>
                    <View style = {styles.titleContainer}>
                        <Text style={styles.title}>{this.state.titles[this.state.selectedIndex]}</Text>
                    </View>
                    {screenWidth > 640 ? 
                        (<View>
                            <View style={[styles.vehiclePickerContainer, styles.containerHorizontal]}>
                                <View style={[{height: 20, paddingTop: 10, paddingRight: 10}]}>
                                    <Picker 
                                        selectedValue = {this.state.selectedVehicleId} 
                                        onValueChange={this.handleVehicleChange}
                                        style={styles.vehiclePicker}
                                    >
                                        <Picker.Item label='select vehicle' value={'selectvehicle'} />
                                        {this.state.vehicleList.map((vehicle)=>(
                                            <Picker.Item 
                                                key={vehicle.vehicleId}
                                                label={vehicle.nickName}
                                                value = {vehicle.vehicleId}
                                            />
                                        ))}
                                    </Picker>
                                </View>
                            
                            {(this.state.selectedIndex===0) && (
                                <View style={[{flexDirection: 'row', justifyContent: 'space-around'}]}>
                                    <View style={[{ paddingRight: 20}]}>
                                        <Text
                                            style={{ color: 'black', fontSize: 14, textAlign: 'center' }}
                                        >
                                            Start Time :
                                        </Text>
                                    
                                        <CustomDatePicker
                                            parentCallBack = {this.handleStartChange}
                                            isDateTimePicker={true}
                                            parentDate={this.state.startDate}
                                        />
                                    </View>
                                    
                                    <View style={[{paddingLeft: 20}]}>
                                        <Text
                                            style={{ color: 'black', fontSize: 14, textAlign: 'center' }}
                                        >
                                            End Time:
                                        </Text>
                                        <CustomDatePicker
                                            parentCallBack = {this.handleEndChange}
                                            isDateTimePicker={true}
                                            parentDate={this.state.endDate}
                                        />
                                    </View>
                                </View>
                            )}
                            {(this.state.selectedIndex===1) && (
                                    <View>
                                        <Text
                                            style={{ color: 'black', fontSize: 14, textAlign: 'center' }}
                                        >
                                            Select a Date:
                                        </Text>
                                        <CustomDatePicker
                                            parentCallBack = {this.handleStartChange}
                                            isDateTimePicker={false}
                                            parentDate={this.state.startDate}
                                        />
                                    </View>                          
                            )}
                            {(this.state.selectedIndex===2) && (
                                <View style={[{flexDirection: 'row', justifyContent: 'space-around'}]}>
                                    <View style={[{paddingRight: 20}]}>
                                        <Text
                                            style={{ color: 'black', fontSize: 14, textAlign: 'center' }}
                                        >
                                            Select a Start Date:
                                        </Text>
                                        
                                        <CustomDatePicker
                                            parentCallBack = {this.handleStartChange}
                                            isDateTimePicker={false}
                                            parentDate={this.state.startDate}
                                        />
                                    </View>
                                    <View style={[{paddingLeft: 20}]}>
                                        <Text
                                            style={{ color: 'black', fontSize: 14, textAlign: 'center' }}
                                        >
                                            Select a End Date:
                                        </Text>
                                        
                                        <CustomDatePicker
                                            parentCallBack = {this.handleEndChange}
                                            isDateTimePicker={false}
                                            parentDate={this.state.endDate}
                                        />
                                    </View>
                                </View>
                            )}
                            <View style={{paddingTop: 20, paddingLeft: 10}}>
                                <Button 
                                    style={styles.reportBtn} 
                                    title='Get Reports' 
                                    onPress={this.btnReport} 
                                />
                            </View>
                        </View>

                    </View>):(<View style={ {padding: 20}}>
                        <View style={[styles.vehiclePickerContainer, styles.containerVertical]}>
                            <View style={{height: this.state.datePickerHeight}}>
                                <Picker 
                                    selectedValue = {this.state.selectedVehicleId} 
                                    onValueChange={this.handleVehicleChange}
                                    style={styles.vehiclePicker}
                                >
                                    <Picker.Item label='select vehicle' value={'selectvehicle'} />
                                    {this.state.vehicleList.map((vehicle)=>(
                                        <Picker.Item 
                                            key={vehicle.vehicleId}
                                            label={vehicle.nickName}
                                            value = {vehicle.vehicleId}
                                        />
                                    ))}
                                </Picker>
                            </View>
                            
                            {(this.state.selectedIndex===0) && (
                                <View>
                                    <View style={[{marginTop:20}]}>
                                        <Text
                                            style={{ color: 'black', fontSize: 14, textAlign: 'center' }}
                                        >
                                            Start Time :
                                        </Text>
                                        <CustomDatePicker
                                            parentCallBack = {this.handleStartChange}
                                            isDateTimePicker={true}
                                        />
                                    </View>
                                    <View style={[{marginTop:40}]}>
                                        <Text
                                            style={{ color: 'black', fontSize: 14, textAlign: 'center' }}
                                        >
                                            End Time:
                                        </Text>
                                        <CustomDatePicker
                                            parentCallBack = {this.handleEndChange}
                                            isDateTimePicker={true}
                                        />
                                    </View>
                                </View>
                            )}
                            {(this.state.selectedIndex===1) && (
                                    <View style={[{marginTop: 20 ,}]}>
                                        <Text
                                            style={{ color: 'black', fontSize: 14, textAlign: 'center' }}
                                        >
                                            Select a Date:
                                        </Text>
                                        <CustomDatePicker
                                            parentCallBack = {this.handleStartChange}
                                            isDateTimePicker={false}
                                        />
                                    </View>                          
                            )}
                            {(this.state.selectedIndex===2) && (
                                <View>
                                    <View style={[{marginTop: 20}]}>
                                        <Text
                                            style={{ color: 'black', fontSize: 14, textAlign: 'center' }}
                                        >
                                            Select a Start Date:
                                        </Text>
                                        <CustomDatePicker
                                            parentCallBack = {this.handleStartChange}
                                            isDateTimePicker={false}
                                        />
                                    </View>
                                    <View style={[{marginTop: 40 }]}>
                                        <Text
                                            style={{ color: 'black', fontSize: 14, textAlign: 'center' }}
                                        >
                                            Select a End Date:
                                        </Text>
                                        <CustomDatePicker
                                            parentCallBack = {this.handleEndChange}
                                            isDateTimePicker={false}
                                        />
                                    </View>
                                </View>
                            )}
                            <View style={{marginTop: 60 }}>
                                <Button 
                                    style={styles.reportBtn} 
                                    title='Get Reports' 
                                    onPress={this.btnReport} 
                                />
                            </View>
                        </View>
                    </View>)}
                </View> 

                <View style={this.state.scrollViewStyle}>
                    
                    {(this.state.reports.length!=0) && (<ReportsTable
                        tableHead = {this.state.tableHead}
                        widthArr = {this.state.widthArr}
                        reports = {this.state.reports}
                        // loading = {this.state.loading}
                        selectedIndex={this.state.selectedIndex}
                        stateReports={this.state.stateReports}
                    />)}
                    <Text style ={styles.loading}>{this.state.loading}</Text> 
                </View>
            </ScrollView>     
        );
    }
}

const styles = StyleSheet.create(
{
  container: {
    flex: 1,
    backgroundColor: 'white',
    marginHorizontal: 0,    
    backgroundColor: 'white',
  },
  buttonsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
    marginRight: 5,
    marginLeft: 5,
    marginTop: 5,
    textAlign: 'center',
  },
  scrollViewContainer: {
    width: '100%',
    marginTop: 100,
    paddingLeft: 20,
    paddingRight: 20,
  },
  scrollViewDatePickerContainer: {
    width: '100%',
    marginRight: 3,
    marginLeft: 3,
    marginTop: '300px',
  },
  containerVertical: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    padding: 20
  },
  containerHorizontal: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  rowContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 10,
  },
  columnContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    marginHorizontal: 50,

  },
  vehiclePickerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    paddingHorizontal: 16,
    marginTop: 16,
    paddingLeft: 20,
    paddingRight: 20,
  },
  vehiclePicker:{
    marginright: 7
  },

  reportBtn: {
    marginLeft: 7,
  },
  text: { 
    margin: 6,
    textAlign: 'center'
  },

  titleContainer: {
    alignItems: 'center'
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    marginRight: 10,
    textAlign: 'center',
  },

  tableTitle: {
    color: 'white',
    backgroundColor: 'rgba(0, 122, 255, 0.8)',
    fontSize: 12,
    padding: 5,
    width: 100,
  },
  loading: { 
    margin: 10,
    textAlign: 'center',
    fontSize: 50,
    opacity: 0.5,
  },
  wrapper: { 
    marginTop: -1,
  },
  btn: {  borderRadius: 2 },
  btnText: {color:'blue', textAlign: 'center' },
});

export default Reports;
